import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { PlusArticleTypeTitle } from "scmp-app/components/plus/plus-article-type-title";

export const Summary = styled.div`
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 20px;
  line-height: 130%;
`;

export const ContentLink = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;

  cursor: pointer;
`;

export const PublishedDate = styled.div`
  margin-block-end: 8px;

  font-weight: 700;
  font-size: 12px;
  line-height: normal;
  text-transform: uppercase;
`;

export const StyledPlusArticleTypeTitle = styled(PlusArticleTypeTitle)`
  margin-block-end: 4px;

  text-transform: uppercase;
`;

export const Section = styled.div`
  margin-block-end: 4px;
  span {
    color: #333333;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
  }
`;

export const Footer = styled.div`
  color: #888888;
  font-size: 14px;
  line-height: 16px;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  font-family: ${fontRobotoCondensed};
`;
